export enum RoutesCommon {
  COMMON = 'common',
  COMMON_CONTRACT = 'contract',
}
